module.exports = __webpack_public_path__ + "static/img/79-2.d5fc653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/79-2.jpg
// module id = Mba0
// module chunks = 0